var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit($event)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { md: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: _vm.$t("common:settings.textOnInvoiceLetter"),
                  type: "text",
                  rows: "4",
                  counter:
                    _vm.value.viestikirjeeseen.length > 1023 ? 1023 : undefined,
                  rules: [
                    _vm.$validationRules.tooManyCharacters(
                      _vm.value.viestikirjeeseen.length,
                      1023
                    ),
                  ],
                  outlined: "",
                },
                model: {
                  value: _vm.value.viestikirjeeseen,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "viestikirjeeseen", $$v)
                  },
                  expression: "value.viestikirjeeseen",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4 pa-3", attrs: { justify: "end" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "ml-4",
              attrs: {
                large: "",
                color: "success",
                type: "submit",
                disabled: !_vm.valid,
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common:save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }